import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"

function Author({ blogAuthor }) {
    const authorName = blogAuthor?.frontmatter?.authorName
    const avatar = blogAuthor?.frontmatter?.avatar
    const avatarAlt = blogAuthor?.frontmatter?.avatarAlt
    return (
        <div className="author mt-5 w-full py-4 md:mt-20">
            <div className="hidden sm:block">
                <p className="ml-2 font-['Work_Sans'] text-[12px] uppercase leading-[36px] text-[#787878]">
                    About the Author
                </p>
            </div>
            <div className="flex w-full flex-row rounded-[20px] bg-[#3165F5] bg-opacity-10 surface:bg-transparent surface:bg-opacity-100">
                <div className="p-2">
                    <div className="group relative mx-auto h-[63px] w-[63px] overflow-hidden rounded-full surface:h-[80px] surface:w-[80px] md:h-[143px] md:w-[143px]">
                        {avatar && <GatsbyImage
                            alt="author-avatar"
                            className="h-full w-full object-cover transition duration-300 group-hover:opacity-0"
                            image={getImage(avatar)}
                        />}
                        <div className="absolute inset-0">
                           {avatarAlt && <GatsbyImage
                                alt="author-avatar"
                                className="h-full w-full object-cover opacity-0 transition duration-300 group-hover:opacity-100"
                                image={getImage(avatarAlt)}
                            />}
                        </div>
                    </div>
                    <div className="mx-auto ml-2 flex flex-row items-baseline pt-2 pb-2 sm:justify-center">
                        <i className="fa-brands fa-linkedin px-2"></i>
                        <i className="fa-brands fa-facebook-square px-2"></i>

                        <i className="fa-brands fa-twitter px-2"></i>
                    </div>
                </div>

                <div className="w-4/5 p-2">
                    <p className="font-['Work_Sans'] text-[10px] leading-[16px] text-[#787878] sm:hidden">
                        About the Author
                    </p>
                    <p className="font-['Work_Sans'] text-[10px] font-bold leading-[18px] text-[#3165F5] md:text-[18px] md:leading-9">
                        {authorName}
                    </p>
                    <div
                        className="font-['Work_Sans'] text-[10px] leading-[16px] md:text-sm md:leading-6"
                        dangerouslySetInnerHTML={{
                            __html: blogAuthor?.html
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default Author
